import { withStyles } from '@material-ui/core/styles'
import Toolbar from '@material-ui/core/Toolbar'
import { Theme } from '@material-ui/core/styles/createMuiTheme'

export const styles = (theme: Theme) => ({
  root: {
    height: 64,
    [theme.breakpoints.up('sm')]: {
      height: 70,
    },
  },
})

export default withStyles(styles)(Toolbar)
